import { ColumnsType } from '@seiue/ui'
import { DataTable, TableQuery } from 'packages/components/DataTable'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { Entrydevice, reflectionApi } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'
import styled from 'styled-components'

/**
 * 账号管理-设备列表
 * 
 * @returns React.FC
 */
export const Device: React.FC = () => {
  const columns: ColumnsType<AnyType> = [
    {
      title: '设备名称',
      key: 'device',
      render: (v: Entrydevice) => {
        return (
          <DeviceWrapper>
            <div>{v.device}</div>
            {v.isCurrent ? <DeviceTag>本机</DeviceTag> : null}
          </DeviceWrapper>
        )
      },
    },
    {
      title: '系统',
      key: 'os',
      dataIndex: 'os',
    },
    {
      title: '浏览器',
      key: 'browser',
      dataIndex: 'browser',
    },
    {
      title: '最近登录',
      key: 'operatedAt',
      dataIndex: 'operatedAt',
    },
    {
      title: '登录地点',
      key: 'address',
      dataIndex: 'address',
    },
  ]

  return (
    <Wrapper>
      <TitleWrapper>设备管理</TitleWrapper>
      <InfoWrapper>
        <GrowpIcon
          name="InfoCircleFill"
          size={16}
          color="#0A6CFF"
        />
        <InfoText>以下是曾经登录过的设备列表</InfoText>
      </InfoWrapper>
      <DataTable
        rowKey={'operatedAt'}
        columns={columns}
        api={(q: TableQuery) => {
          return reflectionApi.queryMeEntrydevices({
            ...q,
          })
        }}
        isPagination={false}
        showSearchForm={false}
        apiName="reflection.queryMeEntrydevices"
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px 0px;
  overflow: scroll;
  height: calc(100vh - 110px);
`

const TitleWrapper = styled.div`
  width: 80px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 8px;
  color: ${(props) => props.theme.text._1};
`

const InfoWrapper = styled.div`
  height: 40px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 16px;
  gap: 8px;
  align-self: stretch;
  background: #e8f5ff;
`

const InfoText = styled.div`
  color: ${(props) => props.theme.text._1};
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0em;
`

const DeviceWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 15px;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
`

const DeviceTag = styled.div`
  font-size: 14px;
  color: #bccdd6;
`
